<button class="avatar" *ngIf="userService.loggedInUser" [matMenuTriggerFor]="menu">
  <div aria-hidden="true" class="hidden-version">{{ version }} - {{ userService.loggedInUser['org_id'] }}</div>
  <img [src]="userService.loggedInUser.picture" alt="profile picture" />
  <span appLongTextTooltip class="user-name">{{ userService.loggedInUser.name }}</span>
  <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
</button>
<mat-menu #menu="matMenu">
  <button class="button disabled" aria-labelledby="role">
    <img src="assets/images/common/user.svg" alt="role" />
    <span id="role"
      >{{ 'menu.role' | labelsProvider }} <b>{{ userService.userPermission | displayCamelCaseString }}</b></span
    >
  </button>
  <button class="button disabled" aria-labelledby="accountName">
    <img src="assets/images/common/customerCompany.svg" alt="accountName" />
    <span id="accountName">{{ userService.accountName }}</span>
  </button>
  <button class="button" (click)="logout()" aria-label="Logout">
    <img src="assets/images/common/logout.svg" alt="logout" />
    <span>{{ 'menu.logout' | labelsProvider }}</span>
  </button>
</mat-menu>
